import React, { Component } from 'react';
import './ProductList.css'

class ProductList extends Component {
    render() {
        return (
            <div>

                <h3 className="text-center txt-main"> Product Summary</h3>
                <table>
                    <thead>
                        <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Image</th>
                            <th scope="col">Hot</th>
                            <th scope="col">Category</th>
                            <th scope="col">Name</th>
                            <th scope="col">Old Price</th>
                            <th scope="col">New Price</th>
                            <th scope="col">View More</th>
                            <th scope="col">Update</th>
                            <th scope="col">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.prods.map((p, key) => {
                                return (
                                    <tr key={key}>
                                        <td scope="row" data-label="Id">{key + 1}</td>
                                        <td data-label="Image"><img style={{width:'100%'}} src={p.img} /></td>
                                        <td data-label="Hot">{p.hot ? 'True' : 'False'}</td>
                                        <td data-label="Category">{p.category}</td>
                                        <td data-label="Name">{p.name}</td>
                                        <td data-label="Old Price">{p.priceOld}</td>
                                        <td data-label="New Price">{p.priceNew}</td>
                                        <td data-label="View More"><button className="btn btn-success"> <i className="fa fa-eye" aria-hidden="true"></i></button></td>
                                        <td data-label="Update"><button className="btn btn-warning"> <i className="fa fa-pencil-square-o" aria-hidden="true"></i></button></td>
                                        <td data-label="Delete"><button className="btn btn-danger"> <i className="fa fa-trash-o" aria-hidden="true"></i></button></td>
                                    </tr>
                                )
                            })
                        }
                        {/* <tr>
                            <td data-label="Account">Visa - 3412</td>
                            <td data-label="Due Date">04/01/2016</td>
                            <td data-label="Amount">$1,190</td>
                            <td data-label="Period">03/01/2016 - 03/31/2016</td>
                        </tr>
                        <tr>
                            <td scope="row" data-label="Account">Visa - 6076</td>
                            <td data-label="Due Date">03/01/2016</td>
                            <td data-label="Amount">$2,443</td>
                            <td data-label="Period">02/01/2016 - 02/29/2016</td>
                        </tr>
                        <tr>
                            <td scope="row" data-label="Account">Corporate AMEX</td>
                            <td data-label="Due Date">03/01/2016</td>
                            <td data-label="Amount">$1,181</td>
                            <td data-label="Period">02/01/2016 - 02/29/2016</td>
                        </tr>
                        <tr>
                            <td scope="row" data-label="Acount">Visa - 3412</td>
                            <td data-label="Due Date">02/01/2016</td>
                            <td data-label="Amount">$842</td>
                            <td data-label="Period">01/01/2016 - 01/31/2016</td>
                        </tr> */}
                    </tbody>
                </table>
            </div>
        );
    }
}

export default ProductList;
